export class KannaValidator {
    public static katakanaValidation(value: string) {
        return /^[\u30A1-\u30F6\u30FC]*$/g.test(value);
    }

    public static halfWidthKatakanaValidation(value: string) {
        return /^[\uFF61-\uFF9F]+$/g.test(value);
    }

    public static hiraganaValidation(value: string) {
        return /^[\u3040-\u309F]+$/g.test(value);
    }
}
